module.exports = __webpack_public_path__ + "fonts/butler_bold_stencil-webfont.f013439.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/butler-stencil/butler_bold_stencil-webfont.woff2
// module id = 569
// module chunks = 0